import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ProductDetails from "./Productdetails";
// import BuyDetails from "./BuyDetails";
import Video from "./Video";
import Map from "./Map";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      className=" capitalize"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }} className=" capitalize">
          <Typography className=" capitalize">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Section({
  des,
  cArea,
  statuss,
  tA,
  refs,
  date,
  type,
  videolink,
}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          textColor="#1E222B"
          TabIndicatorProps={{ style: { background: "#00BC67" } }}
          className=" capitalize "
          indicatorColor="secondary"
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label={
              <p className=" font-[500] text-[16px] capitalize">Details</p>
            }
            {...a11yProps(0)}
          />
          <Tab
            label={<p className="font-[500] text-[16px] capitalize">Video</p>}
            {...a11yProps(1)}
          />
          <Tab
            label={<p className="font-[500] text-[16px] capitalize">Map</p>}
            {...a11yProps(2)}
          />
          <Tab
            label={
              <p className="font-[500] text-[16px] capitalize">
                Schedule Visitation
              </p>
            }
            {...a11yProps(3)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        {/* <BuyDetails
          des={des}
          cArea={cArea}
          statuss={statuss}
          tA={tA}
          refs={refs}
          date={date}
          type={type}
        /> */}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Video url={videolink} />
      </TabPanel>
      {/* <TabPanel value={value} index={2}>
      <div>
      <Map/>
      </div>
     
      </TabPanel> */}
      {/* <TabPanel value={value} index={3}>
        Item FOur
      </TabPanel> */}
    </Box>
  );
}
